module.exports = __webpack_public_path__ + "2d4cd603335c87930a8dc4d49e4c4192.png";